import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export function InventoryLifecycleHelp({ label, children }: { label: string; children: ReactNode }) {
  return <Popover>
    <PopoverTrigger asChild>
      <Button type="button" variant="ghost" size="icon" className="size-7 shrink-0" aria-label={label}>
        <Info className="size-4" />
      </Button>
    </PopoverTrigger>
    <PopoverContent className="max-w-[calc(100vw-2rem)] text-sm">{children}</PopoverContent>
  </Popover>;
}
